<template>
    <vx-popover
        v-if="hasOwnerUser"
        hover
        teleport
        arrow
        placement="top"
        :disabled="props.ownerEmail === ''"
        class="flex! min-w-0 max-w-full cursor-pointer [&>div]:min-w-0"
        @click="copyText(props.ownerEmail)"
    >
        <span data-test="owner" class="block truncate font-semibold text-slate-800">{{ props.owner }}</span>
        <template v-slot:content>
            <div class="text-center">
                <div class="font-semibold">{{ props.owner }}</div>
                {{ props.ownerEmail }}
                <div class="text-xs pt-1 text-slate-500">Click to copy</div>
            </div>
        </template>
    </vx-popover>
    <vx-popover
        v-else-if="inviteBadge"
        hover
        teleport
        arrow
        placement="top"
        class="cursor-pointer"
        @click="copyText(props.ownerEmail)"
    >
        <vx-badge data-test="owner-invite" :color="inviteBadge.color" size="xs">{{ inviteBadge.label }}</vx-badge>
        <template v-slot:content>
            <div class="text-center">
                {{ props.ownerEmail }}
                <div class="text-xs pt-1 text-slate-500">Click to copy</div>
            </div>
        </template>
    </vx-popover>
    <span v-else data-test="no-owner" class="text-slate-500">-</span>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, type VxBadgeColor } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useCopyText } from '~/composables/useCopyText';
import type { KioskTeamGroupOwnerInvite } from '~/services/adminTeamGroupsClient.types';
import { ownerInviteLabel } from './kioskTeamGroupsTableHelpers';

const inviteColors: Record<Exclude<KioskTeamGroupOwnerInvite, 'none'>, VxBadgeColor> = {
    pending: 'amber',
    expired: 'slate',
};

const props = defineProps<{
    owner: string;
    ownerEmail: string;
    ownerInvite: KioskTeamGroupOwnerInvite;
}>();

const { copyText } = useCopyText();

const hasOwnerUser = computed(() => props.owner !== '');

const inviteBadge = computed(() => {
    if (hasOwnerUser.value || props.ownerInvite === 'none' || props.ownerEmail === '') {
        return null;
    }

    return { label: ownerInviteLabel(props.ownerInvite), color: inviteColors[props.ownerInvite] };
});
</script>
